export default {"src":"/_next/static/media/initial.2ccf4fa9.svg","height":761,"width":843,"blurWidth":0,"blurHeight":0};